"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
class Consumers extends React.Component {
    render() {
        const { consumers, children } = this.props;
        let args = [];
        consumers.forEach(ConsumerWrapper => (React.createElement(ConsumerWrapper, null, arg => {
            args.push(arg);
            return React.createElement("span", null);
        })));
        return children(...args);
    }
}
exports.Consumers = Consumers;
//# sourceMappingURL=CustomersWrapper.js.map